// International order terms gate, RecorderGear port of ivue26-intl-gate.js (spec files/specs/2026-10-22-ivue-international-orders-design.md, Dan 2026-10-22).
// Intercepts Check out for international visitors (saved customer address outside the US, or Shopify's detected browsing
// country not US), records the agreement on the cart ("Intl terms: OK YYYY-MM-DD" attribute, shown on the order; kept short because
// ShipStation prints phone + Note From Buyer in the 50-char GlobalPost REF 1 field) and hides the
// express-checkout buttons, which would skip the gate. The pop-up lives in the cart drawer section, which re-renders through
// the Section Rendering API, so everything here looks the dialog up at use time and listens on the document.
(() => {
  const D = () => document.getElementById('rg-intl-gate');
  if (!D() || typeof D().showModal !== 'function') return;
  let intl = null, pending = null, asking = null;
  const detect = () => {
    if (intl !== null) return Promise.resolve(intl);
    const c = D() && D().dataset.custCountry;
    if (c) return Promise.resolve(intl = c !== 'US');
    if (asking) return asking;
    const ctl = new AbortController(); setTimeout(() => ctl.abort(), 1500);
    return asking = fetch('/browsing_context_suggestions.json', { signal: ctl.signal }).then(r => r.json())
      .then(j => (intl = !!(j.detected_values && j.detected_values.country) && j.detected_values.country.handle !== 'US'))
      .catch(() => (intl = false));   // unknown: no gate; the checkout rate description and the emails still inform
  };
  const agreed = () => { try { return sessionStorage.getItem('rgIntlOk') === '1'; } catch (e) { return false; } };
  const hideExpress = () => document.querySelectorAll('[data-intl-express]').forEach(x => { x.hidden = true; });
  detect().then(i => { if (i) hideExpress(); });
  const open = () => { const d = D(); if (d && !d.open) d.showModal(); };
  const go = b => { b.dataset.igPass = '1'; b.form.requestSubmit(b); };

  document.addEventListener('submit', e => {
    const b = e.submitter;
    if (!b || b.name !== 'checkout' || agreed() || b.dataset.igPass) return;
    e.preventDefault();
    detect().then(i => { if (!i) return go(b); pending = b; open(); });
  }, true);

  document.addEventListener('click', async e => {
    const d = D(); if (!d) return;
    if (e.target.closest('[data-ig-open]')) { e.preventDefault(); pending = null; open(); return; }
    if (e.target.closest('[data-ig-close]') || e.target === d) { d.close(); return; }
    if (e.target.closest('[data-ig-ok]')) {
      const day = new Date().toISOString().slice(0, 10);
      try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Intl terms': 'OK ' + day } }) }); } catch (err) {}
      try { sessionStorage.setItem('rgIntlOk', '1'); } catch (err) {}
      d.close();
      // the button says "continue to checkout", so it does, whether the pop-up came from Check out or from the link
      const b = pending && pending.isConnected ? pending : [...document.querySelectorAll('button[name="checkout"]')].find(x => x.offsetParent);
      if (b) go(b);
    }
  });
})();
